<script lang="ts">
  import {Button, Col,Form,FormGroup,Input,InputGroup,InputGroupText,Label,Row} from "sveltestrap";
  import {Browserdefaults,BrowserdefaultsMessage,City,FirstName,LastName,State,SubmitForm,Username,Zip} from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
</script>
  
<Card headerTitle={Browserdefaults} cardHeaderprops="pb-0">
  <div slot="customheader">
      <span>{@html BrowserdefaultsMessage}</span>
  </div>
  <div slot="contentbody">
    <Form class="needs-validation">
      <Row class="g-3">
        <Col md="4">
          <Label for="validationCustom01">{FirstName}</Label>
          <Input
            id="validationCustom01"
            type="text"
            placeholder="Mark"
            name="fName"
            required
          />
        </Col>
        <Col md="4">
          <Label for="validationCustom02">{LastName}</Label>
          <Input
            id="validationCustom02"
            type="text"
            placeholder="Last name"
            name="lName"
            required
          />
        </Col>
        <Col md="4" class="mb-3">
          <Label for="validationCustomUsername">{Username}</Label>
          <InputGroup>
            <InputGroupText>{"@"}</InputGroupText>
            <Input
              name="userName"
              type="text"
              placeholder="Username"
              required
            />
          </InputGroup>
        </Col>
      </Row>
      <Row class="g-3">
        <Col md="6">
          <Label for="validationCustom03">{City}</Label>
          <Input
            id="validationCustom03"
            type="text"
            placeholder="City"
            required
          />
        </Col>
        <Col md="3">
          <Label for="validationCustom04">{State}</Label>
          <Input type="select" name="select" value="Choose..." placeholder="State" id="validationCustom04" required >
            <option>Choose...</option>
            <option>...</option>
          </Input>
        </Col>
        <Col md="3" class="mb-3">
          <Label for="validationCustom05">{Zip}</Label>
          <Input
            id="validationCustom05"
            type="text"
            placeholder="Zip"
            name="zip"
            required
          />
        </Col>
      </Row>
      <div class="mb-3">
        <div class="form-check">
            <div class="checkbox p-0">
            <FormGroup>
                <Input
                id="c2"
                type="checkbox"
                label="Agree to terms and conditions"
                />
            </FormGroup>
            </div>
            <div class="invalid-feedback">
                {'You must agree before submitting.'}
            </div>
        </div>
      </div>
      <Button color="primary" type="submit">{SubmitForm}</Button>
    </Form>
  </div>
</Card>
  